<template>
  <router-link
      :to="to"
      class="recommended-products-more fontsize-mini text-black px-3  mt-4 d-inline-block"
  >
    <span > {{title}} </span>
  <!-- <ArrowLeft class="icon" fill="#000"/> -->
  </router-link>
</template>

<script>
// import ArrowLeft from "@/parts/Front/nicecomponents/svgs/ArrowLeft";
export default {
  name: "MoreButton",
  inject: ['mediaQueries'],
  // components: {ArrowLeft},
  props: {
    to: String,
    title: {
      type: String,
      default: "مشاهده همه "
    }
  }
}
</script>

<style scoped>
.icon {
  transition: 200ms all;
}
.recommended-products-more:hover .icon {
  transform: translateX(3px);
}
.recommended-products-more {
  /*background: var(--newTheme-color);*/
  background:transparent;
  padding-block: 10px 8px;
  border: 1px solid var(--newTheme-color);
  border-radius: 5px;
  color: var(--newTheme-color);
}

.recommended-products-more:hover {
  background:var(--newTheme-color);
  color: white;
}

</style>
